import { api } from '@/app'
import { BASE_URL } from './constants'
import { PaginationResponse, QueryManager } from '@/packages'
import { analytics } from '../../analytics'
import { Organisation } from '@/types'
import { queryClient } from '../queryClient'
import { organisationQueryKeys } from './queryKeys'
import { TypeGuards } from '@codeleap/types'
import { useMutation, useQuery } from '@tanstack/react-query'

type OrganizationFilters = {
  name?: string
  show_unverified?: boolean
  sort_by?: 'name' | '-min_employees' | '-max_employees'
}

async function getUnknownOrganisation() {
  const response = await api.get<Organisation>(`${BASE_URL}unknown/`)

  return response.data
}

export const organisationsManager = new QueryManager({
  itemType: {} as Organisation,
  name: 'organisations',
  queryClient: queryClient.client,

  listItems: async (limit, offset, filters: OrganizationFilters) => {

    const response = await api.get<PaginationResponse<Organisation>>(BASE_URL, {
      params: {
        limit,
        offset,

        ...filters,
        name: filters.name?.trim() || undefined,
      },
    })

    return response.data
  },

  createItem: async (data) => {
    const response = await api.post(BASE_URL, data)

    return response.data
  },

  retrieveItem: async (id) => {
    if (TypeGuards.isNil(id)) return undefined
    const response = await api.get<Organisation>(`${BASE_URL}${id}/`)

    return response.data
  },

})

export const useUnknownOrganisation = () => {
  const query = useQuery({
    queryKey: organisationQueryKeys.unknownOrganisation,
    queryFn: getUnknownOrganisation,
    select: (data) => {
      organisationsManager.updateItems(data)
      return data
    },
  })

  return {
    query,
    organisation: query.data,
  }
}

export function getOrganisationInvolved() {
  return api.get(`${BASE_URL}get_involved/`)
}

export async function contact(organisationId: Organisation['id']) {

  const response = await api.post(`${BASE_URL}contact/`, {
    organization: organisationId,
  })

  return response.data
}

export function useContact(organisation: Organisation) {
  const mut = useMutation({
    mutationFn: contact,

  })

  const onContact = async () => {
    analytics.track('Info_requested', {
      organization: organisation?.name,
    })
    mut.mutateAsync(organisation.id)

  }

  return {
    contact: onContact,
    isSuccess: mut.isSuccess,
    isLoading: mut.isPending,
  }
}
